export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    body: {
      type: String,
      required: true,
    },

    openByDefault: {
      type: Boolean,
      default: false,
    },

    dataAttributes: {
      type: Object,
      default: () => {},
    },

    index: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isOpen: this.openByDefault,
    }
  },

  computed: {
    questionNumber() {
      return (this.index + 1).toString().padStart(2)
    },
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
  },
}
